import { IConfirmLeaveGroup } from '../../../interfaces/components/modal.interface';
import { ConfirmModalVerse2 } from '../../modal/training-module/ConfirmModal';

const ConfirmLeaveGroup = ({
  callback,
  isOpen,
  handleClose,
}: IConfirmLeaveGroup) => {
  return (
    <div>
      <ConfirmModalVerse2
        open={isOpen}
        onClose={handleClose}
        cancelCallback={callback}
        confirmCallback={handleClose}
        title={'Thông báo'}
        description={
          'Khi rời khỏi nhóm, bạn sẽ mất quyền truy cập nội dung khóa học, tài liệu miễn phí và tính phí trong Cộng đồng Dược Khoa'
        }
        confirmContent={'Huỷ'}
        cancelContent={'Rời nhóm'}
        buttonFloatRight
      />
    </div>
  );
};

export default ConfirmLeaveGroup;
